import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  changeFieldQuizChangeAnswer,
  changeFieldQuizDeleteAnswer
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import {
  selectAllErrors,
  selectFieldQuiz,
  selectQuizAnswerErrorByKeys
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';
import { t } from 'utils/translates';
import connect from 'react-redux/es/connect/connect';
import _ from 'lodash';

// eslint-disable-next-line react/prefer-stateless-function
class QuizAscInput extends Component {
  constructor(props) {
    super(props);
    this.inputName = `${props.fieldQuiz.field}_${props.keyAsk}_${props.keyAnswer}`;
    this.inputRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (_.isEmpty(prevProps.allErrors) && !_.isEmpty(this.props.allErrors)) {
      const firstErrorField = Object.keys(this.props.allErrors)[0];
      if (firstErrorField.includes(this.inputName)) {
        this.inputRef.current.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }

  render() {
    const hasErrorQuizAnswer = (keyAsk, keyAnswer) =>
      this.props.selectQuizAnswerErrorByKeys(keyAsk, keyAnswer);
    const errorQuizAnswerDesc = (keyAsk, keyAnswer) => {
      if (this.props.selectQuizAnswerErrorByKeys(keyAsk, keyAnswer)) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {
                this.props.selectQuizAnswerErrorByKeys(keyAsk, keyAnswer)[0]
                  .message
              }
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    const numAnswer = this.props.keyAnswer + 1;
    return (
      <React.Fragment>
        <div
          className={`form-group ${
            hasErrorQuizAnswer(this.props.keyAsk, this.props.keyAnswer)
              ? 'has-error'
              : ''
          }`}
        >
          <div className="input-group">
            <span className="input-group-addon">{numAnswer}</span>
            <input
              ref={this.inputRef}
              className="form-control"
              placeholder={t('Введите Ответ на ваш вопрос')}
              type="text"
              id="answer1-1"
              value={this.props.valueAnswer}
              onChange={e => {
                this.props.changeFieldQuizChangeAnswer({
                  keyAsk: this.props.keyAsk,
                  keyAnswer: this.props.keyAnswer,
                  value: e.target.value
                });
              }}
            />
            {this.props.keyAnswer > 0 ? (
              <span className="input-group-btn">
                <button
                  className="btn btn-default"
                  data-placement="top"
                  data-toggle="tooltip"
                  type="button"
                  data-original-title={t('Удалить')}
                  onClick={() => {
                    this.props.changeFieldQuizDeleteAnswer({
                      keyAsk: this.props.keyAsk,
                      keyAnswer: this.props.keyAnswer
                    });
                  }}
                >
                  <i className="fa fa-trash" />
                </button>
              </span>
            ) : null}
          </div>
          {errorQuizAnswerDesc(this.props.keyAsk, this.props.keyAnswer)}
        </div>
      </React.Fragment>
    );
  }
}

QuizAscInput.propTypes = {
  // IN
  keyAsk: PropTypes.number.isRequired,
  keyAnswer: PropTypes.number.isRequired,
  valueAnswer: PropTypes.string.isRequired,

  // CONNECT
  fieldQuiz: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  allErrors: PropTypes.shape({}).isRequired,

  selectQuizAnswerErrorByKeys: PropTypes.func.isRequired,
  changeFieldQuizChangeAnswer: PropTypes.func.isRequired,
  changeFieldQuizDeleteAnswer: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  fieldQuiz: selectFieldQuiz(state, props.reducerName),
  allErrors: selectAllErrors(state, props.reducerName),
  selectQuizAnswerErrorByKeys: (keyAsk, keyAnswer) =>
    selectQuizAnswerErrorByKeys(state, props.reducerName, keyAsk, keyAnswer)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldQuizChangeAnswer: payload =>
    dispatch(
      changeFieldQuizChangeAnswer(props.reducerName, {
        keyAsk: payload.keyAsk,
        keyAnswer: payload.keyAnswer,
        value: payload.value
      })
    ),
  changeFieldQuizDeleteAnswer: payload =>
    dispatch(
      changeFieldQuizDeleteAnswer(props.reducerName, {
        keyAsk: payload.keyAsk,
        keyAnswer: payload.keyAnswer
      })
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuizAscInput);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/CheckTaskInputs/CheckTypeQuiz/QuizAscInput/_QuizAscAnswerInput.js